import HttpService from "../Http/HttpService";
import Logger from "../Logger/Logger";
import Validator from "../Validator/Validator";
import {
    API_GET_ALL_BOOKING_MESSAGES,
    API_GET_BOOKING_MESSAGES_LOAD_ABOVE,
    API_GET_BUSINESS_MESSAGE_COUNT,
    API_GET_BUSINESS_MESSAGES,
} from "./WhatsappConstant";

interface BusinessMessageCountApiResponse {
    isSuccess: boolean;
    response?: {
        businessId?: number;
        exists?: boolean;
        count?: {
            total?: number;
            outward?: number;
            inward?: number;
        };
    };
}

export default class WhatsappService {
    private httpService = new HttpService()
    private logger = new Logger();
    private validator = new Validator();

    public getAllBookingMessages = async (params: { limit?: number; offset?: number } = {}) => {
        try {
            const response = await this.httpService.get(API_GET_ALL_BOOKING_MESSAGES, params);
            return response.data;
        } catch (error) {
            this.logger.error("Error while fetching booking messages: error: " + JSON.stringify(error));
            throw error;
        }
    }

    public loadBookingMessagesAbove = async (params: { phoneNumber: string; table: "inward" | "outward"; tableId: number }) => {
        try {
            const response = await this.httpService.get(API_GET_BOOKING_MESSAGES_LOAD_ABOVE, params);
            return response.data;
        } catch (error) {
            this.logger.error("Error while loading booking messages above: error: " + JSON.stringify(error));
            throw error;
        }
    }

    public getBusinessMessageCount = async (businessId: number): Promise<BusinessMessageCountApiResponse> => {
        try {
            this.validator.isNumberGreaterThan("businessId", businessId, 0);
            const response = await this.httpService.get(API_GET_BUSINESS_MESSAGE_COUNT, { businessId });
            return response.data;
        } catch (error) {
            this.logger.error("Error while fetching business message count: error: " + JSON.stringify(error));
            throw error;
        }
    }

    public getBusinessMessages = async (businessId: number) => {
        try {
            this.validator.isNumberGreaterThan("businessId", businessId, 0);
            const response = await this.httpService.get(API_GET_BUSINESS_MESSAGES, { businessId });
            return response.data;
        } catch (error) {
            this.logger.error("Error while fetching business messages: error: " + JSON.stringify(error));
            throw error;
        }
    }

}